module.exports = __webpack_public_path__ + "img/home.7643a32b.svg";